<template>
  <section>
    <div v-if="!$store.state.utils.loaded" class="main-loading">
      <strong>Loading....</strong>
    </div>
  </section>
</template>

<script>
export default {
  name: "Loading",
  metaInfo: {
    title: "Loading",
    titleTemplate: "%s | NEW ABC APP",
  },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {},
};
</script>

<style>
.main-loading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99999;
  display: grid;
  align-items: center;
  justify-content: center;
  background-color: #333;
  color: #eee;
  transition: all 0.5s ease-in-out;
}
</style>
